{
  "error.cookie_needed.description": "브라우저가 쿠키 및 로컬 저장소를 차단하도록 설정되어 있습니다.\n브라우저 기본 설정의 쿠키가 Experience Cloud에 액세스할 수 있도록 허용하십시오.",
  "error.cookie_needed.heading": "쿠키가 차단됨",
  "error.cookie_needed.refreshBtn": "새로 고침",
  "error.not_found.description": "이 페이지는 사용할 수 없습니다. URL을 확인하거나 다른 페이지를 방문하십시오.",
  "error.not_found.heading": "오류 404: 페이지를 찾을 수 없음",
  "error.offline.description": "인터넷 연결을 확인하고 페이지를 새로 고칩니다.",
  "error.offline.heading": "인터넷 연결 없음",
  "error.rate_limit.description": "우리는 많은 양을 처리하고 있습니다. 페이지를 다시 로드하거나 몇 분 후에 다시 시도하십시오.\n이 메시지를 계속 받는 경우, 고객 지원 센터에 문의하고 다음을 참조하십시오.\nEIM 인스턴스 ID {instanceId}",
  "error.rate_limit.heading": "오류 429: 속도 제한",
  "error.rate_limit.refreshBtn": "새로 고침",
  "error.timeout.description": "이 페이지를 로드할 수 없습니다. 새로 고침하거나 다른 페이지를 방문하십시오.\n이 메시지를 계속 받는 경우, 고객 지원 센터에 문의하고 다음을 참조하십시오.\nEIM 인스턴스 ID {instanceId}",
  "error.timeout.heading": "오류 408: 요청 시간 초과",
  "error.timeout.refreshBtn": "새로 고침",
  "error.unknown.description": "페이지가 올바르게 로드되지 않았습니다.로그인을 확인하고 다시 시도하십시오.\n이 메시지를 계속 받는 경우, 고객 지원 센터에 문의하고 다음을 참조하십시오.\nEIM 인스턴스 ID {instanceId}",
  "error.unknown.heading": "페이지를 로드하지 못함",
  "error.unknown.refreshBtn": "새로 고침"
}
